module.exports = __webpack_public_path__ + "img/dark-main-demo.22eb77dd.webp";